import React from "react";
import { RequireRole } from "../../app/router/RequireRole";
import { HonorariosPage } from "./pages/HonorariosPage";
import { PagosPage } from "./pages/PagosPage";
import { CarteraPage } from "./pages/CarteraPage";
import { CarteraFinancieraPage } from "./pages/CarteraFinancieraPage";

/**
 * Billing feature routes — TASK-16 (R6: owned exclusively by src/features/billing/).
 *
 * ── Protected (RequireRole OWNER) ────────────────────────────────────────────
 *   /:slug/app/academia/dinero/honorarios  HonorariosPage  — preview + liquidar + histórico
 *   /:slug/app/academia/dinero/pagos       PagosPage       — registro de pagos + recibo
 *   /:slug/app/academia/dinero/cartera     CarteraPage     — cartera vencida (ciclos INTERRUPTED)
 *
 * Register in AppRouter.js (two lines — R6):
 *   import billingRoutes from '../../features/billing/routes';
 *   registry.register(billingRoutes);
 */
const billingRoutes = [
  {
    path: "/:slug/app/academia/dinero",
    element: <RequireRole roles={["OWNER"]} />,
    children: [
      { path: "honorarios", element: <HonorariosPage /> },
      { path: "pagos", element: <PagosPage /> },
      // "Cartera" ahora es la financiera (saldos pendientes + abonos).
      { path: "cartera", element: <CarteraFinancieraPage /> },
      // La antigua "Cartera" (ciclos interrumpidos) es ahora "Retención".
      { path: "retencion", element: <CarteraPage /> },
    ],
  },
];

export default billingRoutes;
